const translations = {
    pt: {
        markAsRead: "Marcar como lida",
        markAllAsRead: "Marcar todas como lidas",
        noNotifications: "Sem notificações",
        errorLoading: "Erro ao carregar notificações.",
        errorMarkingAsRead: "Erro ao marcar notificação como lida. Tente novamente.",
        errorMarkingAllAsRead: "Erro ao marcar todas as notificações como lidas. Tente novamente.",
        viewAll: "Ver todas",
        unread: "não lidas",
        notifications: "Notificações",
        loading: "Carregando..."
    },
    en: {
        markAsRead: "Mark as read",
        markAllAsRead: "Mark all as read",
        noNotifications: "No notifications",
        errorLoading: "Error loading notifications.",
        errorMarkingAsRead: "Error marking notification as read. Please try again.",
        errorMarkingAllAsRead: "Error marking all notifications as read. Please try again.",
        viewAll: "View all",
        unread: "unread",
        notifications: "Notifications",
        loading: "Loading..."
    },
};


export default translations;